import { render } from "./AccessCodePaymentAuditPage.vue?vue&type=template&id=fab578b6"
import script from "./AccessCodePaymentAuditPage.vue?vue&type=script&lang=js"
export * from "./AccessCodePaymentAuditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__